import * as React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { RouterWrapper } from './router/router-wrapper';

export const App = () => {
  return (
    <Router>
      <RouterWrapper />
    </Router>
  );
};